import { FormProvider, useForm } from "react-hook-form"
import { DepreciationType, depreciationValidation } from "../../utils"
import { FormDepreciation } from "../FormSection"
import { defaultValueDepreciation } from "../../utils/vars"
import { useContext } from "react"
import { FormDataContext } from "../../context"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import { useApi } from "utils"

export function TabDepreciation() {

    const api = useApi()

    const { dataAsset, refecth } = useContext(FormDataContext)

    // use form
    const method = useForm<DepreciationType>({
        defaultValues: defaultValueDepreciation(dataAsset ?? {}),
        resolver: yupResolver(depreciationValidation)
    })


    const onSubmit = (data: DepreciationType) => {

        const finalData = { ...data, asset_id: dataAsset?.asset_id }
        const formData = new FormData()

        Object.entries(finalData).forEach(([key, value]) => {
            formData.append(key, String(value));
        })

        const url = dataAsset?.asset_infodepreciation_id
            ? `/assetdepre/update_asset_infodeprecaition?asset_infodepreciation_id=${dataAsset?.asset_infodepreciation_id}`
            : "/assetdepre/update_asset_infodeprecaition";

        return new Promise<void>((resolve) => {
            toast.promise(
                api.put(url, formData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {

                refecth()

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <FormProvider {...method}>
            <FormDepreciation onSubmit={method.handleSubmit(onSubmit)} />
        </FormProvider>
    )
}